module.exports = __webpack_public_path__ + "img/yejingjing.0b779cb6.jpg";